import React, {useEffect, useState} from 'react';
import {Spinner} from "../../../components";
import Dashboard from "../../../layouts/dashboard";
import SupplierTable from "../../../components/new-dashboard/company/supplier-table";
import LineChart from "../../../components/charts/lineChart";

const Index = () => {
    const [loadPage, setLoadPage] = useState(true);
    const [spinColor, setSpinColor] = useState("success");

    useEffect(() => {

        let tim2 = setTimeout(() => {
            setLoadPage(false);
        }, 100);

        return () => {
            clearInterval(tim2);
        };
    }, []);

    return (
        <>
            {
                loadPage ? (
                    <>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100vh",
                                width: "100%",
                                position: "fixed",
                                left: 0,
                                top: 0,
                            }}
                        >
                            <Spinner color={spinColor} size={3} />
                        </div>
                    </>
                ) : (
                    <Main />
                )
            }
        </>
    );
};

export default Index;

export const Main = () => {
    return (
        <>
            <Dashboard>
                <div className="">
                    <h1>Graphiques</h1>
                    <div className="row">
                        <div className="col-md-6">
                            <LineChart/>
                        </div>
                        <div className="col-md-6">
                            <LineChart/>
                        </div>
                    </div>
                </div>
            </Dashboard>
        </>
    )
}